function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H400V260H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C5DDFF",
  d: "M200 25c74.558 0 135 60.442 135 135 0 35.551-13.742 67.893-36.204 92.003H101.204C78.742 227.893 65 195.55 65 160c0-74.558 60.442-135 135-135z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 262,
  height: 2,
  x: 69,
  y: 251,
  fill: "#CEE0FF",
  rx: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 365 36) translate(177.692 186.905)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M34.544 13.728H14.11l-5.65 6.72v6.479h31.734v-6.479l-5.65-6.72zM30.57 1.056H18.083c-.525 0-1.01.193-1.383.516s-.633.777-.707 1.297l-1.554 10.858h19.776L32.66 2.87c-.074-.52-.334-.974-.707-1.297-.373-.323-.858-.516-1.384-.516z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5C8DF6",
  d: "M22.739 7.92h3.176c.583 0 1.056.472 1.056 1.056 0 .583-.473 1.056-1.056 1.056H22.74c-.584 0-1.056-.473-1.056-1.056 0-.584.472-1.056 1.056-1.056z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.115,
  height: 5.808,
  x: 23.269,
  y: 17.951,
  fill: "#5C8DF6",
  rx: 1.056
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5C8DF6",
  d: "M1.32 25.871h46.014c.729 0 1.32.591 1.32 1.32 0 .729-.591 1.32-1.32 1.32H1.32C.591 28.51 0 27.92 0 27.19c0-.729.591-1.32 1.32-1.32z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#92BFFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.973 1.056H11.104v27.455h15.869V1.056zM11.635 37.487c-2.922 0-5.567 1.182-7.481 3.093-1.914 1.91-3.098 4.55-3.098 7.466v7.392H5.29v-7.392c0-1.75.71-3.334 1.859-4.48 1.148-1.147 2.734-1.856 4.486-1.856h14.807c1.752 0 3.338.71 4.486 1.856 1.148 1.146 1.859 2.73 1.859 4.48v7.392h4.234v-7.392c0-1.631-.37-3.179-1.37-4.549-.913-1.25-2.332-2.34-4.394-3.246-3.96-1.74-10.174-2.764-19.622-2.764z",
  transform: "matrix(-1 0 0 1 365 36) rotate(4 -1899.555 2741.126)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.603 28.511H9.473L4.426 37.42 9.4 44.35h19.277l4.975-6.93-5.049-8.909z",
  transform: "matrix(-1 0 0 1 365 36) rotate(4 -1899.555 2741.126)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M25.386 1.056H1.056v29.567h24.33V1.056z",
  transform: "matrix(-1 0 0 1 365 36) rotate(20 -93.875 649.938) translate(0 11.616)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M2.115 8.448H4.23V29.567H2.115z",
  transform: "matrix(-1 0 0 1 365 36) rotate(20 -93.875 649.938) translate(0 11.616)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 365 36) rotate(20 -93.875 649.938)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 13.221,
  cy: 13.2,
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  rx: 12.165,
  ry: 12.144
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 .528)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5C8DF6",
  d: "M17.091 1.13l.002.002c.375.446.317 1.112-.13 1.487L2.376 14.84c-.447.374-1.112.316-1.486-.13l-.002-.002c-.375-.446-.317-1.111.129-1.486l.001-.001L15.605 1c.446-.374 1.111-.316 1.486.13zM25.553 10.634l.001.002c.375.446.318 1.111-.129 1.486v.001l-14.587 12.22c-.447.374-1.112.316-1.487-.13l-.681-.811 15.396-12.898c.447-.374 1.112-.316 1.487.13z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 13.221,
  cy: 12.672,
  fill: "#92BFFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  rx: 2.646,
  ry: 2.64
})))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M21.156 1.056h-20.1v27.455h20.1V1.056z",
  transform: "matrix(-1 0 0 1 365 36) rotate(20 -93.875 649.938) translate(2.115 41.182)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M2.115 2.112H4.23V23.231H2.115z",
  transform: "matrix(-1 0 0 1 365 36) rotate(20 -93.875 649.938) translate(2.115 41.182)"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#92BFFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  transform: "matrix(-1 0 0 1 365 36) rotate(20 -93.875 649.938) translate(1.587 57.55)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 11.635,
  cy: 11.616,
  rx: 10.579,
  ry: 10.56
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 11.635,
  cy: 11.616,
  rx: 5.819,
  ry: 5.808
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#5C8DF6",
  d: "M37.019 12.672H109.471V28.511000000000003H37.019z",
  transform: "matrix(-1 0 0 1 365 36) translate(108.413) translate(2.115 63.886)"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#5C8DF6",
  strokeWidth: 2.112
}, /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  d: "M62.934 1.056H16.423L1.704 22.609l36.449 10.126h22.67c.583 0 1.11-.237 1.493-.619.382-.382.618-.91.618-1.493V1.056z",
  transform: "matrix(-1 0 0 1 365 36) translate(108.413) translate(2.115 63.886) translate(84.615)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M57.643 6.336H58.643V32.735H57.643z",
  transform: "matrix(-1 0 0 1 365 36) translate(108.413) translate(2.115 63.886) translate(84.615)"
})), /*#__PURE__*/React.createElement("g", {
  stroke: "#5C8DF6",
  strokeWidth: 2.112
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M59.232 1.056H2.252l23.572 28.35 33.408-9.786V1.056z",
  transform: "matrix(-1 0 0 1 365 36) translate(108.413) translate(2.115 63.886) translate(0 3.176)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  d: "M59.006 1.056H2.27l20.377 24.2 33.555-9.83 2.804-14.37z",
  transform: "matrix(-1 0 0 1 365 36) translate(108.413) translate(2.115 63.886) translate(0 3.176)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M73.074 1.056H1.494l2.21 6.255c.198.558.62 1.007 1.164 1.239l10.134 4.317c.848.36 1.554.99 2.011 1.789l3.088 5.4c.188.328.457.594.773.778.317.184.681.285 1.06.285l30.862-.006c.694-.054 1.322-.447 1.67-1.058l3.227-5.626c.456-.692 1.106-1.236 1.872-1.562L69.85 8.479c.471-.247.834-.663 1.013-1.168l2.21-6.255z",
  transform: "matrix(-1 0 0 1 365 36) translate(108.413) translate(2.115 63.886) translate(38.077 3.168)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  d: "M71.577 2.112L70.83 4.224 3.737 4.224 3.173 2.629 3.173 2.112z",
  transform: "matrix(-1 0 0 1 365 36) translate(108.413) translate(2.115 63.886) translate(38.077 3.168)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 365 36) translate(108.413) translate(2.115 63.886) translate(38.077 3.168) translate(20.096 6.336)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  d: "M8.463 5.28c.583 0 1.056.473 1.056 1.056v2.112c0 .583-.473 1.056-1.056 1.056H4.23c-.583 0-1.056-.473-1.056-1.056V6.336c0-.583.473-1.056 1.056-1.056h4.234zm23.27 0c.583 0 1.055.473 1.055 1.056v2.112c0 .583-.472 1.056-1.056 1.056h-4.234c-.583 0-1.056-.473-1.056-1.056V6.336c0-.583.473-1.056 1.056-1.056h4.234zM8.462 0C9.046 0 9.52.473 9.52 1.056v2.112c0 .583-.473 1.056-1.056 1.056H1.056C.473 4.224 0 3.75 0 3.168V1.056C0 .473.473 0 1.056 0h7.407zm26.443 0c.583 0 1.056.473 1.056 1.056v2.112c0 .583-.473 1.056-1.056 1.056h-7.408c-.583 0-1.056-.473-1.056-1.056V1.056c0-.583.473-1.056 1.056-1.056h7.408z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5C8DF6",
  d: "M8.463 5.28c.583 0 1.056.473 1.056 1.056 0 .583-.473 1.056-1.056 1.056H4.23c-.583 0-1.056-.473-1.056-1.056 0-.583.473-1.056 1.056-1.056h4.234zm23.27 0c.583 0 1.055.473 1.055 1.056 0 .583-.472 1.056-1.055 1.056h-4.235c-.583 0-1.056-.473-1.056-1.056 0-.583.473-1.056 1.056-1.056h4.235zM8.463 0C9.046 0 9.52.473 9.52 1.056c0 .583-.473 1.056-1.056 1.056H1.056C.473 2.112 0 1.639 0 1.056 0 .473.473 0 1.056 0h7.407zm26.443 0c.583 0 1.056.473 1.056 1.056 0 .583-.473 1.056-1.056 1.056h-7.408c-.583 0-1.056-.473-1.056-1.056 0-.583.473-1.056 1.056-1.056h7.408z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 11.635,
  height: 7.392,
  x: 12.163,
  y: 2.112,
  fill: "#92BFFF",
  rx: 1.584
}), /*#__PURE__*/React.createElement("rect", {
  width: 9.523,
  height: 5.28,
  x: 13.219,
  y: 1.056,
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  rx: 1.584
})))), /*#__PURE__*/React.createElement("path", {
  fill: "#5C8DF6",
  d: "M146.49 36.43l18.533 7.837c.913.386 1.435 1.355 1.254 2.33l-6.726 36.296h-13.06V36.43z",
  transform: "matrix(-1 0 0 1 365 36) translate(108.413)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 365 36) translate(108.413) translate(0 7.392)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M38.018 1.52L1.758 14.459c-.211.075-.386.212-.51.386-.122.174-.192.385-.192.608v43.558c0 .29.118.554.308.745.19.191.454.31.744.31l35.97.12-.06-58.666z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 11.635,
  height: 13.727,
  x: 11.106,
  y: 23.759,
  fill: "#92BFFF",
  rx: 2.112
}), /*#__PURE__*/React.createElement("rect", {
  width: 9.523,
  height: 11.615,
  x: 12.162,
  y: 22.703,
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  rx: 2.112
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5C8DF6",
  d: "M1.587 50.686L37.548 50.686 37.548 52.798 1.587 52.798z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  d: "M2.115 52.798L37.019 52.798 37.019 54.91 2.115 54.91z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M10.05 1.6L1.056 5.45v58.437h8.994V1.6z",
  transform: "matrix(-1 0 0 1 365 36) translate(108.413) matrix(-1 0 0 1 108.942 4.224)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  fillRule: "nonzero",
  d: "M9.519 62.83L2.115 62.83 2.115 8.065 9.519 4.752z",
  transform: "matrix(-1 0 0 1 365 36) translate(108.413) matrix(-1 0 0 1 108.942 4.224)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M1.113 1.498l44.764 15.34c.199.068.368.192.492.351.123.16.201.354.218.563l3.038 37.686H1.057l.056-53.94z",
  transform: "matrix(-1 0 0 1 365 36) translate(108.413) translate(102.067 5.28) translate(3.702)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 365 36) translate(108.413) translate(102.067 5.28) translate(3.702) translate(6.875 15.84)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 11.635,
  height: 12.672,
  y: 2.112,
  fill: "#92BFFF",
  rx: 2.112
}), /*#__PURE__*/React.createElement("rect", {
  width: 9.523,
  height: 10.56,
  x: 1.056,
  y: 1.056,
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  rx: 2.112
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 365 36) translate(108.413) translate(102.067 5.28) translate(3.702) translate(25.385 32.735)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  d: "M2.112 2.112h14.814c1.167 0 2.112.945 2.112 2.112v11.615c0 1.167-.945 2.112-2.112 2.112H2.112C.946 17.951 0 17.006 0 15.84V4.224c0-1.167.946-2.112 2.112-2.112z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M16.926 1.056H2.112c-.292 0-.556.118-.747.31-.19.19-.309.454-.309.746v11.615c0 .292.118.556.31.747.19.191.454.31.746.31h14.814c.292 0 .556-.119.747-.31.191-.191.31-.455.31-.747V2.112c0-.292-.119-.556-.31-.747-.19-.19-.455-.309-.747-.309z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.115,
  height: 4.224,
  x: 12.163,
  y: 4.752,
  fill: "#5C8DF6",
  rx: 1.056
}))), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M49.713 55.438H4.752c-1.02 0-1.945.414-2.614 1.082-.668.67-1.082 1.593-1.082 2.614 0 1.02.414 1.944 1.082 2.613.67.669 1.593 1.083 2.614 1.083h44.961v-7.392z",
  transform: "matrix(-1 0 0 1 365 36) translate(108.413) translate(102.067 5.28)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M49.71 55.438v7.392h2.654c1.02 0 1.944-.414 2.613-1.083s1.082-1.593 1.082-2.613-.413-1.945-1.082-2.614c-.669-.668-1.593-1.082-2.613-1.082H49.71z",
  transform: "matrix(-1 0 0 1 365 36) translate(108.413) translate(102.067 5.28)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M6.348 1.518L1.056 3.482v56.18h5.292V1.518z",
  transform: "matrix(-1 0 0 1 365 36) translate(108.413) translate(37.02 8.448)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  d: "M5.288 4.542L5.288 58.606 2.115 58.606 2.115 5.598z",
  transform: "matrix(-1 0 0 1 365 36) translate(108.413) translate(37.02 8.448)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M55.532 1.056H2.112c-.292 0-.556.118-.747.31-.19.19-.309.454-.309.746v64.941c0 .292.118.556.31.747.19.191.454.31.746.31h53.42c.292 0 .556-.119.747-.31.191-.19.31-.455.31-.747V2.112c0-.292-.119-.556-.31-.747-.191-.19-.455-.309-.747-.309z",
  transform: "matrix(-1 0 0 1 365 36) translate(108.413) translate(42.308)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  d: "M8.987 39.599h46.542v23.23H8.987c-1.166 0-2.112-.945-2.112-2.111V41.71c0-1.167.946-2.112 2.112-2.112z",
  transform: "matrix(-1 0 0 1 365 36) translate(108.413) translate(42.308)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  d: "M23.27.528v35.903h-2.116V.528h2.115zm-19.04 0v35.903H2.116V.528h2.116z",
  transform: "matrix(-1 0 0 1 365 36) translate(108.413) translate(42.308) translate(20.096 1.584)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5C8DF6",
  d: "M2.115 0v36.959H0V0h2.115zm19.039 0v36.959h-2.116V0h2.116z",
  transform: "matrix(-1 0 0 1 365 36) translate(108.413) translate(42.308) translate(20.096 1.584)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M49.713 1.056H2.112c-.292 0-.556.118-.747.31-.19.19-.309.454-.309.746v19.007c0 .292.118.556.31.747.19.19.454.31.746.31h47.601V1.055z",
  transform: "matrix(-1 0 0 1 365 36) translate(108.413) translate(42.308) translate(6.875 38.015)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  d: "M45.218 14.255c.73 0 1.32.591 1.32 1.32v1.584c0 .73-.59 1.32-1.32 1.32h-8.994c-.73 0-1.32-.59-1.32-1.32v-1.584c0-.729.59-1.32 1.32-1.32h8.994zm0-4.751c.73 0 1.32.59 1.32 1.32v1.583c0 .73-.59 1.32-1.32 1.32h-8.994c-.73 0-1.32-.59-1.32-1.32v-1.583c0-.73.59-1.32 1.32-1.32h8.994zm0-4.752c.73 0 1.32.59 1.32 1.32v1.584c0 .729-.59 1.32-1.32 1.32h-8.994c-.73 0-1.32-.591-1.32-1.32V6.072c0-.73.59-1.32 1.32-1.32h8.994z",
  transform: "matrix(-1 0 0 1 365 36) translate(108.413) translate(42.308) translate(6.875 38.015)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5C8DF6",
  d: "M45.483 14.255c.583 0 1.055.473 1.055 1.056 0 .584-.472 1.056-1.055 1.056H35.96c-.583 0-1.056-.472-1.056-1.056 0-.583.473-1.056 1.056-1.056h9.523zm0-4.751c.583 0 1.055.472 1.055 1.056 0 .583-.472 1.056-1.055 1.056H35.96c-.583 0-1.056-.473-1.056-1.056 0-.584.473-1.056 1.056-1.056h9.523zm0-4.752c.583 0 1.055.473 1.055 1.056 0 .583-.472 1.056-1.055 1.056H35.96c-.583 0-1.056-.473-1.056-1.056 0-.583.473-1.056 1.056-1.056h9.523z",
  transform: "matrix(-1 0 0 1 365 36) translate(108.413) translate(42.308) translate(6.875 38.015)"
})))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M27.502 1.056H1.056v20.591h26.446V1.056z",
  transform: "matrix(-1 0 0 1 365 36) translate(0 37.487) translate(81.971 3.168)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5C8DF6",
  d: "M6.346 0H8.461V22.703H6.346zM13.221 0H15.336V22.703H13.221z",
  transform: "matrix(-1 0 0 1 365 36) translate(0 37.487) translate(81.971 3.168)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  d: "M2.115 18.479L6.346 18.479 6.346 20.591 2.115 20.591zM8.462 18.479L13.221 18.479 13.221 20.591 8.462 20.591zM15.337 18.479L26.442 18.479 26.442 20.591 15.337 20.591z",
  transform: "matrix(-1 0 0 1 365 36) translate(0 37.487) translate(81.971 3.168)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 365 36) translate(0 37.487) translate(0 26.399)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5C8DF6",
  d: "M2.115 6.336c.292 0 .53.236.53.528v.528H22.74v2.112H2.644v.528c0 .291-.237.528-.529.528H.53c-.292 0-.529-.237-.529-.528V6.864c0-.292.237-.528.529-.528h1.586z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M83.561 6.336H19.564c-.292 0-.556.118-.747.31-.19.19-.31.454-.31.746v1.584c0 .291.12.555.31.746.191.191.455.31.747.31H83.56c.292 0 .556-.119.747-.31.19-.19.31-.455.31-.746V7.392c0-.292-.12-.556-.31-.747-.191-.191-.455-.31-.747-.31z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M54.03 6.336H33.443l3.446 6.863h10.248l6.893-6.863z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 59.495,
  cy: 7.92,
  fill: "#92BFFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  rx: 6.612,
  ry: 6.864
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5C8DF6",
  d: "M57.115 6.336h4.76v2.64c0 .583-.473 1.056-1.056 1.056h-2.648c-.583 0-1.056-.473-1.056-1.056v-2.64zM38.606 5.28L40.721 5.28 40.721 14.255 38.606 14.255zM43.365 5.28L45.481 5.28 45.481 14.255 43.365 14.255z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 365 36) translate(0 37.487) translate(11.635)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M70.833 3.42c-.105-.574-.433-1.05-.877-1.358-.445-.307-1.007-.445-1.58-.34L19.1 10.727c-.385.07-.734.245-1.017.494-.283.25-.5.575-.617.948L10.96 32.786h59.907L70.833 3.42z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 31.202,
  cy: 19.535,
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  rx: 9.521,
  ry: 9.24
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5C8DF6",
  d: "M2.644 24.815c.292 0 .53.236.53.528v.528h30.672v2.112H3.173v.528c0 .292-.237.528-.529.528H.53c-.292 0-.529-.236-.529-.528v-3.168c0-.292.237-.528.529-.528h2.115z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  d: "M47.593 21.647h22.215v8.976H47.593c-1.167 0-2.112-.946-2.112-2.112v-4.752c0-1.166.945-2.112 2.112-2.112z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M70.867 20.591H47.593c-.292 0-.556.118-.747.31-.191.19-.31.455-.31.746V26.4c0 .292.119.556.31.747.191.19.455.309.747.309h23.274V20.59z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.115,
  height: 7.392,
  x: 64.519,
  y: 5.28,
  fill: "#5C8DF6",
  rx: 1.058
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5C8DF6",
  fillRule: "nonzero",
  d: "M63.784 19.774C62.012 12.657 57 6.895 50.469 4.067l-6.782.98c8.438.99 15.394 7.164 17.441 15.387l2.656-.66z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 31.466,
  cy: 19.799,
  fill: "#92BFFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  rx: 2.381,
  ry: 2.376
}), /*#__PURE__*/React.createElement("rect", {
  width: 6.878,
  height: 8.976,
  x: 32.787,
  y: 18.479,
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  rx: 2.112
}), /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  d: "M33.846 19.535L38.606 19.535 38.606 21.647 33.846 21.647z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5C8DF6",
  d: "M15.865 14.783L22.74 14.783 21.683 16.895 15.337 16.895zM14.279 19.535L21.683 19.535 21.683 21.647 13.75 21.647z"
})))), /*#__PURE__*/React.createElement("g", {
  fill: "#92BFFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.973 1.056H11.104v27.455h15.869V1.056zM11.635 37.487c-2.922 0-5.567 1.182-7.481 3.093-1.914 1.91-3.098 4.55-3.098 7.466v7.392H5.29v-7.392c0-1.75.71-3.334 1.859-4.48 1.148-1.147 2.734-1.856 4.486-1.856h14.807c1.752 0 3.338.71 4.486 1.856 1.148 1.146 1.859 2.73 1.859 4.48v7.392h4.234v-7.392c0-1.631-.37-3.179-1.37-4.549-.913-1.25-2.332-2.34-4.394-3.246-3.96-1.74-10.174-2.764-19.622-2.764z",
  transform: "matrix(-1 0 0 1 365 36) rotate(-45 234.43 -41.09)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.603 28.511H9.473L4.426 37.42 9.4 44.35h19.277l4.975-6.93-5.049-8.909z",
  transform: "matrix(-1 0 0 1 365 36) rotate(-45 234.43 -41.09)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M25.386 1.056H1.056v29.567h24.33V1.056z",
  transform: "matrix(-1 0 0 1 365 36) rotate(20 -137.419 385.477) translate(0 11.616)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M2.115 8.448H4.23V29.567H2.115z",
  transform: "matrix(-1 0 0 1 365 36) rotate(20 -137.419 385.477) translate(0 11.616)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 365 36) rotate(20 -137.419 385.477)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 13.221,
  cy: 13.2,
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  rx: 12.165,
  ry: 12.144
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 .528)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5C8DF6",
  d: "M17.091 1.13l.002.002c.375.446.317 1.112-.13 1.487L2.376 14.84c-.447.374-1.112.316-1.486-.13l-.002-.002c-.375-.446-.317-1.111.129-1.486l.001-.001L15.605 1c.446-.374 1.111-.316 1.486.13zM25.553 10.634l.001.002c.375.446.318 1.111-.129 1.486v.001l-14.587 12.22c-.447.374-1.112.316-1.487-.13l-.681-.811 15.396-12.898c.447-.374 1.112-.316 1.487.13z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 13.221,
  cy: 12.672,
  fill: "#92BFFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  rx: 2.646,
  ry: 2.64
})))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M21.156 1.056h-20.1v27.455h20.1V1.056z",
  transform: "matrix(-1 0 0 1 365 36) rotate(20 -137.419 385.477) translate(2.115 41.182)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M2.115 2.112H4.23V23.231H2.115z",
  transform: "matrix(-1 0 0 1 365 36) rotate(20 -137.419 385.477) translate(2.115 41.182)"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#92BFFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  transform: "matrix(-1 0 0 1 365 36) rotate(20 -137.419 385.477) translate(1.587 57.55)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 11.635,
  cy: 11.616,
  rx: 10.579,
  ry: 10.56
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 11.635,
  cy: 11.616,
  rx: 5.819,
  ry: 5.808
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M16.925 1.056H1.056v27.455h15.869V1.056z",
  transform: "matrix(-1 0 0 1 365 36) rotate(-3 2780.971 -4123.25) translate(10.048)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  d: "M15.865 0v10.956c-1.926 1.41-4.303 2.244-6.875 2.244-2.571 0-4.948-.833-6.874-2.244V0h13.75z",
  transform: "matrix(-1 0 0 1 365 36) rotate(-3 2780.971 -4123.25) translate(10.048)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M11.635 37.487c-2.922 0-5.567 1.182-7.481 3.093-1.914 1.91-3.098 4.55-3.098 7.466v7.392H5.29v-7.392c0-1.75.71-3.334 1.859-4.48 1.148-1.147 2.734-1.856 4.486-1.856h14.807c1.752 0 3.338.71 4.486 1.856 1.148 1.146 1.859 2.73 1.859 4.48v7.392h4.234v-7.392c0-1.631-.37-3.179-1.37-4.549-.913-1.25-2.332-2.34-4.394-3.246-3.96-1.74-10.174-2.764-19.622-2.764z",
  transform: "matrix(-1 0 0 1 365 36) rotate(-3 2780.971 -4123.25)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M25.43 1.056H6.3L1.252 9.965l4.975 6.93h19.277l4.975-6.93-5.049-8.909z",
  transform: "matrix(-1 0 0 1 365 36) rotate(-3 2780.971 -4123.25) translate(3.173 27.455)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  d: "M28.555 8.717L29.224 9.898 24.959 15.839 6.772 15.839 2.506 9.898 3.175 8.717 6.772 13.727 24.959 13.727z",
  transform: "matrix(-1 0 0 1 365 36) rotate(-3 2780.971 -4123.25) translate(3.173 27.455)"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M16.925 1.056H1.056v27.455h15.869V1.056z",
  transform: "matrix(-1 0 0 1 365 36) rotate(2 -3920.81 3127.698) translate(10.048)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  d: "M15.865 0v10.956c-1.926 1.41-4.303 2.244-6.875 2.244-2.571 0-4.948-.833-6.874-2.244V0h13.75z",
  transform: "matrix(-1 0 0 1 365 36) rotate(2 -3920.81 3127.698) translate(10.048)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M11.635 37.487c-2.922 0-5.567 1.182-7.481 3.093-1.914 1.91-3.098 4.55-3.098 7.466v7.392H5.29v-7.392c0-1.75.71-3.334 1.859-4.48 1.148-1.147 2.734-1.856 4.486-1.856h14.807c1.752 0 3.338.71 4.486 1.856 1.148 1.146 1.859 2.73 1.859 4.48v7.392h4.234v-7.392c0-1.631-.37-3.179-1.37-4.549-.913-1.25-2.332-2.34-4.394-3.246-3.96-1.74-10.174-2.764-19.622-2.764z",
  transform: "matrix(-1 0 0 1 365 36) rotate(2 -3920.81 3127.698)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M25.43 1.056H6.3L1.252 9.965l4.975 6.93h19.277l4.975-6.93-5.049-8.909z",
  transform: "matrix(-1 0 0 1 365 36) rotate(2 -3920.81 3127.698) translate(3.173 27.455)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  d: "M28.555 8.717L29.224 9.898 24.959 15.839 6.772 15.839 2.506 9.898 3.175 8.717 6.772 13.727 24.959 13.727z",
  transform: "matrix(-1 0 0 1 365 36) rotate(2 -3920.81 3127.698) translate(3.173 27.455)"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M25.386 1.056H1.056v29.567h24.33V1.056z",
  transform: "matrix(-1 0 0 1 365 36) rotate(6 -618.97 1182.577) translate(0 11.616)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  d: "M24.327 0v10.86c-2.354 3.632-6.449 6.035-11.106 6.035S4.47 14.491 2.114 10.858L2.115 0h22.212z",
  transform: "matrix(-1 0 0 1 365 36) rotate(6 -618.97 1182.577) translate(0 11.616)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 365 36) rotate(6 -618.97 1182.577)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 13.221,
  cy: 13.2,
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  rx: 12.165,
  ry: 12.144
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 .528)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5C8DF6",
  d: "M17.091 1.13l.002.002c.375.446.317 1.112-.13 1.487L2.376 14.84c-.447.374-1.112.316-1.486-.13l-.002-.002c-.375-.446-.317-1.111.129-1.486l.001-.001L15.605 1c.446-.374 1.111-.316 1.486.13zM25.553 10.634l.001.002c.375.446.318 1.111-.129 1.486v.001l-14.587 12.22c-.447.374-1.112.316-1.487-.13l-.681-.811 15.396-12.898c.447-.374 1.112-.316 1.487.13z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 13.221,
  cy: 12.672,
  fill: "#92BFFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  rx: 2.646,
  ry: 2.64
})))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M21.156 1.056h-20.1v27.455h20.1V1.056z",
  transform: "matrix(-1 0 0 1 365 36) rotate(6 -618.97 1182.577) translate(2.115 41.182)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  d: "M2.115 2.112L20.096 2.112 20.096 4.224 2.115 4.224z",
  transform: "matrix(-1 0 0 1 365 36) rotate(6 -618.97 1182.577) translate(2.115 41.182)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 365 36) rotate(6 -618.97 1182.577) translate(1.587 57.55)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 11.635,
  cy: 11.616,
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  rx: 10.579,
  ry: 10.56
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 11.635,
  cy: 11.616,
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  rx: 5.819,
  ry: 5.808
}), /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  d: "M11.635 6.864c2.628 0 4.76 2.127 4.76 4.752 0 .27-.023.534-.067.792-.377-2.248-2.335-3.96-4.693-3.96-2.359 0-4.317 1.712-4.694 3.96-.043-.258-.066-.522-.066-.792 0-2.625 2.131-4.752 4.76-4.752z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M25.386 1.056H1.056v29.567h24.33V1.056z",
  transform: "matrix(-1 0 0 1 365 36) rotate(-4 1160.486 -3117.806) translate(0 11.616)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  d: "M24.327 0v10.86c-2.354 3.632-6.449 6.035-11.106 6.035S4.47 14.491 2.114 10.858L2.115 0h22.212z",
  transform: "matrix(-1 0 0 1 365 36) rotate(-4 1160.486 -3117.806) translate(0 11.616)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 365 36) rotate(-4 1160.486 -3117.806)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 13.221,
  cy: 13.2,
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  rx: 12.165,
  ry: 12.144
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 .528)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5C8DF6",
  d: "M17.091 1.13l.002.002c.375.446.317 1.112-.13 1.487L2.376 14.84c-.447.374-1.112.316-1.486-.13l-.002-.002c-.375-.446-.317-1.111.129-1.486l.001-.001L15.605 1c.446-.374 1.111-.316 1.486.13zM25.553 10.634l.001.002c.375.446.318 1.111-.129 1.486v.001l-14.587 12.22c-.447.374-1.112.316-1.487-.13l-.681-.811 15.396-12.898c.447-.374 1.112-.316 1.487.13z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 13.221,
  cy: 12.672,
  fill: "#92BFFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  rx: 2.646,
  ry: 2.64
})))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M21.156 1.056h-20.1v27.455h20.1V1.056z",
  transform: "matrix(-1 0 0 1 365 36) rotate(-4 1160.486 -3117.806) translate(2.115 41.182)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  d: "M2.115 2.112L20.096 2.112 20.096 4.224 2.115 4.224z",
  transform: "matrix(-1 0 0 1 365 36) rotate(-4 1160.486 -3117.806) translate(2.115 41.182)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 365 36) rotate(-4 1160.486 -3117.806) translate(1.587 57.55)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 11.635,
  cy: 11.616,
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  rx: 10.579,
  ry: 10.56
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 11.635,
  cy: 11.616,
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  rx: 5.819,
  ry: 5.808
}), /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  d: "M11.635 6.864c2.628 0 4.76 2.127 4.76 4.752 0 .27-.023.534-.067.792-.377-2.248-2.335-3.96-4.693-3.96-2.359 0-4.317 1.712-4.694 3.96-.043-.258-.066-.522-.066-.792 0-2.625 2.131-4.752 4.76-4.752z"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 365 36) translate(216.298 188.49)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M34.544 13.728H14.11l-5.65 6.72v6.479h31.734v-6.479l-5.65-6.72z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  d: "M34.05 14.783l1.775 2.111H12.829l1.775-2.11H34.05z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M30.57 1.056H18.083c-.525 0-1.01.193-1.383.516s-.633.777-.707 1.297l-1.554 10.858h19.776L32.66 2.87c-.074-.52-.334-.974-.707-1.297-.373-.323-.858-.516-1.384-.516z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5C8DF6",
  d: "M22.739 7.92h3.176c.583 0 1.056.472 1.056 1.056 0 .583-.473 1.056-1.056 1.056H22.74c-.584 0-1.056-.473-1.056-1.056 0-.584.472-1.056 1.056-1.056z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.115,
  height: 5.808,
  x: 23.269,
  y: 17.951,
  fill: "#5C8DF6",
  rx: 1.056
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5C8DF6",
  d: "M1.32 25.871h46.014c.729 0 1.32.591 1.32 1.32 0 .729-.591 1.32-1.32 1.32H1.32C.591 28.51 0 27.92 0 27.19c0-.729.591-1.32 1.32-1.32z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 365 36) translate(99.952 187.961)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M34.544 13.728H14.11l-5.65 6.72v6.479h31.734v-6.479l-5.65-6.72z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  d: "M34.05 14.783l1.775 2.111H12.829l1.775-2.11H34.05z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M30.57 1.056H18.083c-.525 0-1.01.193-1.383.516s-.633.777-.707 1.297l-1.554 10.858h19.776L32.66 2.87c-.074-.52-.334-.974-.707-1.297-.373-.323-.858-.516-1.384-.516z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5C8DF6",
  d: "M22.739 7.92h3.176c.583 0 1.056.472 1.056 1.056 0 .583-.473 1.056-1.056 1.056H22.74c-.584 0-1.056-.473-1.056-1.056 0-.584.472-1.056 1.056-1.056z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.115,
  height: 5.808,
  x: 23.269,
  y: 17.951,
  fill: "#5C8DF6",
  rx: 1.056
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5C8DF6",
  d: "M1.32 25.871h46.014c.729 0 1.32.591 1.32 1.32 0 .729-.591 1.32-1.32 1.32H1.32C.591 28.51 0 27.92 0 27.19c0-.729.591-1.32 1.32-1.32z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 365 36) rotate(-45 293.85 -59.585)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#92BFFF",
  stroke: "#5C8DF6",
  strokeWidth: 2.112,
  d: "M34.544 13.728H14.11l-5.65 6.72v6.479h31.734v-6.479l-5.65-6.72zM30.57 1.056H18.083c-.525 0-1.01.193-1.383.516s-.633.777-.707 1.297l-1.554 10.858h19.776L32.66 2.87c-.074-.52-.334-.974-.707-1.297-.373-.323-.858-.516-1.384-.516z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5C8DF6",
  d: "M22.739 7.92h3.176c.583 0 1.056.472 1.056 1.056 0 .583-.473 1.056-1.056 1.056H22.74c-.584 0-1.056-.473-1.056-1.056 0-.584.472-1.056 1.056-1.056z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.115,
  height: 5.808,
  x: 23.269,
  y: 17.951,
  fill: "#5C8DF6",
  rx: 1.056
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5C8DF6",
  d: "M1.32 25.871h46.014c.729 0 1.32.591 1.32 1.32 0 .729-.591 1.32-1.32 1.32H1.32C.591 28.51 0 27.92 0 27.19c0-.729.591-1.32 1.32-1.32z"
}))));

var SvgAtMAgaPicEmpty = function SvgAtMAgaPicEmpty(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 260,
    viewBox: "0 0 400 260",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAtMAgaPicEmpty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/at-m-aga-pic-empty.a5fa218b.svg";
export { ForwardRef as ReactComponent };